import React from 'react'
import data from '../../data/locData';

function General() {
    const general = data.location.about
    const listItemStyle = data.settings
    return (
        <>
            <div id="generalSection" className="generalSection v8__promo  displaySection">
                <div className="container">
                    <div className="colrowWrap">
                        <div className="rowFlex">
                            {
                                general.map((item, i) => {
                                    return (
                                        <div className="generalFlex" key={i}>
                                            <div className="leftBox">
                                                <div className="headTitle">
                                                    <h2 style={{color: listItemStyle.primaryColor}}>{item.title}</h2>
                                                    <p style={{color: listItemStyle.darkColor}}>{item.description}</p>
                                                </div>
                                            </div>
                                            <div className="rightBox">
                                                <img src={item.img} alt="cooks-entertains"/>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default General